import z from 'zod';
import { PATIENT_CARD_REPORT_TYPES } from '@/components/patient-card/patient-card-data';
import {
  DATE_RANGE_PRESETS,
  DEFAULT_DATE_RANGE_PRESET,
} from '@/features/patient-360/consts/date-range-preset';

export const sharedSearchParams = z.object({
  mrn: z.string().optional(),
  preset: z
    .enum(DATE_RANGE_PRESETS)
    .optional()
    .default(DEFAULT_DATE_RANGE_PRESET),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
});

export const reportTypeSchema = z.enum(PATIENT_CARD_REPORT_TYPES);

export const reportSearchParams = z.object({
  reportId: z.string().optional(),
  reportType: reportTypeSchema.optional(),
  from: z.string().optional(),
});
